<template>
  <div id="demo">
    <b-carousel
     id="carousel-fade"
    style="text-shadow: 0px 0px 2px #000;"
    fade
    indicators
    img-width="1024"
    img-height="480"
    class="shadow"
    >
     <!-- <b-carousel-slide 
       img-src="https://wallpaperaccess.com/full/3980368.jpg"
      ></b-carousel-slide> -->
      <!-- Text slides with image -->
      <b-carousel-slide v-for="(item,index) in slide_info" :key="index"
        :img-src="item.info_img"
     ></b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
// import $ from "jquery";
import axios from "axios";
export default {
  name: "slider",
  data() {
    return {
      slide_info: [],
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      slide: 0,
      sliding: null,
    };
  },
  mounted() {
    this.getslide();
  },
  methods: {
    getslide() {
      let data = {
        token: this.token,
      };
      const headers = {
        "content-type": "application/json",
    
      };
      // this.$isLoading(true);
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/booking/get_info_web",
          data,
          { headers }
        )
        .then((res) => {
          // console.log("slider ===",res);
          
      
          this.slide_info = res.data.info_web;
          // this.$isLoading(false);
        
        });
    },
  
     
  },
  
};
</script>

<style scoped>

.carousel {
  border-radius: 0;
  
}
img {
  border-radius: 0;
}

</style>
